import { render } from "./xfxl.vue?vue&type=template&id=606b2715&scoped=true"
import script from "./xfxl.vue?vue&type=script&lang=js"
export * from "./xfxl.vue?vue&type=script&lang=js"

import "./xfxl.vue?vue&type=style&index=0&id=606b2715&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606b2715"]])

export default __exports__